import { RxEventHistoryResponseSchema } from '@/types/rx/prescriptionDetails';

import { getJeanieAxiosClient } from './axiosClient';

export async function getRxEventHistory(accessToken: string, prescriptionUuid: string) {
    const axiosClient = getJeanieAxiosClient(accessToken);

    const { data } = await axiosClient.get(`dashboard/v1/rx-events?rx_uuid=${prescriptionUuid}`);

    return RxEventHistoryResponseSchema.parse(data);
}
